import React from 'react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { mockData } from '../data/mock';
import { CheckCircle } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.15 } })
};

const Services = () => {
  const { services } = mockData;

  const images = [
    "https://images.pexels.com/photos/34211795/pexels-photo-34211795.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://static.prod-images.emergentagent.com/jobs/e29e1e74-dfad-4ff0-a54e-5cee69b74787/images/08c41ac579fb6bc774275d77aa826ee85d2455f19ab678740d0ec6bb5f6a2af5.png"
  ];

  return (
    <section id="services" className="py-24 sm:py-32 bg-[#FAFAF9]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          custom={0}
        >
          <span 
            className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            Nos Services
          </span>
          <h2 
            className="mt-4 text-4xl sm:text-5xl tracking-tight leading-tight font-normal text-[#1C1917]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Expertise Artisanale
          </h2>
          <p 
            className="mt-4 text-lg leading-relaxed text-[#57534E] max-w-xl"
            style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
          >
            Découvrez nos services de retouches professionnelles, adaptés à tous vos besoins
          </p>
        </motion.div>
        
        {/* Bento Grid */}
        <div className="mt-16 grid lg:grid-cols-2 gap-8 lg:gap-12">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border border-[#E8D5D1]/30"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={fadeUp}
              custom={index + 1}
              data-testid={`service-card-${index}`}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={images[index]}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              
              {/* Content */}
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <h3 
                    className="text-2xl font-normal text-[#1C1917]"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {service.title}
                  </h3>
                  <span 
                    className="text-sm font-medium text-[#D4AF37] bg-[#D4AF37]/10 px-4 py-1.5 rounded-full"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                  >
                    {service.price}
                  </span>
                </div>
                
                <p 
                  className="text-[#57534E] mb-6"
                  style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
                >
                  {service.description}
                </p>
                
                <div className="space-y-3 mb-8">
                  {service.features.map((feature, fi) => (
                    <div key={fi} className="flex items-center gap-3">
                      <CheckCircle className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                      <span className="text-sm text-[#57534E]" style={{ fontFamily: "'Outfit', sans-serif" }}>{feature}</span>
                    </div>
                  ))}
                </div>
                
                <Button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="w-full bg-[#1C1917] hover:bg-[#1C1917]/90 text-white font-medium py-5 rounded-full tracking-wide transition-all duration-300"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                  data-testid={`service-cta-${index}`}
                >
                  Nous contacter
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
